import { Card } from "@insights/ui";
import { useParams } from "react-router";
import { LoginPage } from "../../auth";
import { Loading } from "../../../shared/components";
import { useInvitation } from "../hooks/useInvitation";

export function InvitationLoginPage() {
  const { id } = useParams();
  const invitation = useInvitation(id);
  if (invitation.isLoading) {
    return <Loading />;
  }
  if (invitation.isError) {
    return (
      <main className="auth-shell">
        <Card className="auth-card">
          <h2>Invitation unavailable</h2>
          <p>This invitation is invalid, expired, or no longer pending.</p>
        </Card>
      </main>
    );
  }
  return (
    <LoginPage
      invitation
      returnTo={`/invitations/${id}`}
      initialEmail={invitation.data!.recipientEmail}
      initialSignup={!invitation.data!.hasAccount}
    />
  );
}
